// Colors names directly picked form figma
export const colors = {
  white: "#FFFFFF",
  black: "#000000",
  grey900: "#171717",
  grey500: "#737373",
  red: "red",
  grayNeutral300: "#D4D4D4", // Will be uses as border/divider color for all components
  grayNeutral100: "#F5F5F5",
  primaryBlue: "#213E7C",
  secondaryBlue: "#4A90E3",
  secondaryOrange: "#F37220",
  primaryGreen: "#213E7C",
  bgGrey: "#F6F8FB",
  cardTextColor : '#A5ADBA',
  // Custom Color names
  grey200: "#9CA3AF",
  grey600: "#404040",
  grey800: "#F4F8F9",
  grey700: "#404040",
  lightBlue: "#DFE7F8",
  red200: "#FF6058",
  red300: "#FED3D1",
  red600: "#D72C0D",
  red100: "#E0B3B2",
  orange: "#F5A621",
  orange500: "#FFEA8A",
  green500: "#D1FAE5",
  green200: "green",
  brown:'#8A6116',
  gry1000 : '#6B7280'
};
